
import axios from 'axios'
import { formatHash } from '../models/hash';
import { apiUrls } from './api';

export class DownloadService {
  constructor () {
    this.generateDownloadLinkURL = apiUrls.generateDownloadLink;
  }

  async generateDownloadLink (hash, type) {
    hash = formatHash(hash);
    
    const response = await axios({
      method: 'POST',
      url: `${this.generateDownloadLinkURL}?hash=${hash}&type=${type}`
    });

    return response.data.download_link;
  }

}